// @ts-strict-ignore
import { Dispatch } from 'redux'

import { addCompareItemSuccess } from 'store/slices/compare'
import { CategoryListProps } from 'store/types/compare'

import { getCategoryParents } from '@/entities/categories'

import { TSection } from '@/shared/types/deprecated-types'

import { Nullable } from '../utilsTypes'

/** It's adding a product to the compare list.
 * @param productKOD
 * @param SECTION_ID
 * @param categories
 * @param dispatch
 * */
export const addToCompare = (
	productKOD: string,
	SECTION_ID: number,
	categories: TSection[],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	dispatch: Dispatch<any>
): Nullable<void> => {
	const itemCategory = categories.find(item => item.id === SECTION_ID?.toString())
	const parentCategory = getCategoryParents(categories, itemCategory)
	const parentCategoryCode = parentCategory[0].code
	const currentCategory = parentCategoryCode !== `aksessuary` ? parentCategory[0] : itemCategory

	const actionPayload = {
		productKOD,
		category: currentCategory as CategoryListProps
	}

	dispatch(addCompareItemSuccess({ ...actionPayload }))
}
